import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RolYonetimiPage = () => {
  const [roller, setRoller] = useState([]);
  const [moduller, setModuller] = useState([]);
  const [seciliRol, setSeciliRol] = useState(null);
  const [rolYetkileri, setRolYetkileri] = useState([]);
  const [yeniRolForm, setYeniRolForm] = useState({ anahtar: '', baslik: '' });
  const [panel, setPanel] = useState('yetkiler');
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = async () => {
    const [r, m] = await Promise.all([
      axios.get('/api/admin/roller').then(r => r.data),
      axios.get('/api/admin/moduller').then(r => r.data),
    ]);
    setRoller(r);
    setModuller(m);
    if (r.length > 0 && !seciliRol) {
      seciliRolSec(r[0]);
    }
  };

  const seciliRolSec = async (rol) => {
    setSeciliRol(rol);
    const yetkiler = await axios.get('/api/admin/roller/' + rol.anahtar + '/yetkiler').then(r => r.data);
    setRolYetkileri(yetkiler);
  };

  useEffect(() => { yukle(); }, []);

  const yetkileriGuncelle = async () => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/admin/roller/' + seciliRol.anahtar + '/yetkiler', { moduller: rolYetkileri });
      setSonuc({ tip: 'basari', mesaj: 'Yetkiler guncellendi.' });
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const anahtarDonustur = (deger) => {
    return (deger || '')
      .replace(/\u011e/g, 'G').replace(/\u011f/g, 'g')
      .replace(/\u00dc/g, 'U').replace(/\u00fc/g, 'u')
      .replace(/\u015e/g, 'S').replace(/\u015f/g, 's')
      .replace(/\u0130/g, 'I').replace(/\u0131/g, 'i')
      .replace(/\u00d6/g, 'O').replace(/\u00f6/g, 'o')
      .replace(/\u00c7/g, 'C').replace(/\u00e7/g, 'c')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  };

  const yeniRolOlustur = async (e) => {
    e.preventDefault();
    if (!yeniRolForm.anahtar || !yeniRolForm.baslik) {
      setSonuc({ tip: 'hata', mesaj: 'Anahtar ve baslik zorunludur.' });
      return;
    }
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/admin/roller', { anahtar: yeniRolForm.anahtar, baslik: yeniRolForm.baslik });
      setSonuc({ tip: 'basari', mesaj: 'Rol olusturuldu.' });
      setYeniRolForm({ anahtar: '', baslik: '' });
      setPanel('yetkiler');
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const rolSil = async (anahtar) => {
    if (!window.confirm('Bu rolu silmek istediginize emin misiniz?')) return;
    try {
      await axios.delete('/api/admin/roller/' + anahtar);
      if (seciliRol?.anahtar === anahtar) setSeciliRol(null);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Silinemedi.' }); }
  };

  const toggleModul = (anahtar) => {
    setRolYetkileri(p => p.includes(anahtar) ? p.filter(m => m !== anahtar) : [...p, anahtar]);
  };

  const gruplar = [...new Set(moduller.map(m => m.grup))];

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Rol Yonetimi</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Rolleri ve modul yetkilerini yonetin.</p>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1.5rem', alignItems: 'start' }}>
        <div>
          <div className="card" style={{ padding: '0.75rem', marginBottom: '1rem' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.5rem', padding: '0 0.25rem' }}>Roller</p>
            {roller.map(r => (
              <div key={r.anahtar} style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
                <button type="button" onClick={() => seciliRolSec(r)}
                  style={{ flex: 1, textAlign: 'left', padding: '0.5rem 0.75rem', border: 'none', borderRadius: 'var(--radius-sm)', cursor: 'pointer', background: seciliRol?.anahtar === r.anahtar ? 'var(--mavi-acik)' : 'transparent', color: seciliRol?.anahtar === r.anahtar ? 'var(--mavi)' : 'var(--yazi)', fontSize: '13px', fontWeight: seciliRol?.anahtar === r.anahtar ? '500' : '400' }}>
                  {r.baslik}
                  {r.sistem_rolu ? <span style={{ fontSize: '10px', color: 'var(--gri-400)', marginLeft: '4px' }}>sistem</span> : null}
                </button>
                {!r.sistem_rolu && (
                  <button type="button" className="btn btn-danger btn-sm" style={{ padding: '2px 8px', fontSize: '11px' }} onClick={() => rolSil(r.anahtar)}>Sil</button>
                )}
              </div>
            ))}
          </div>
          <button type="button" className="btn btn-primary" style={{ width: '100%' }} onClick={() => { setPanel(panel === 'yeni-rol' ? 'yetkiler' : 'yeni-rol'); setSonuc(null); setYeniRolForm({ anahtar: '', baslik: '' }); }}>
            + Yeni Rol
          </button>
        </div>

        <div>
          {panel === 'yeni-rol' ? (
            <div className="card">
              <div className="card-header"><h2>Yeni Rol Olustur</h2></div>
              <form onSubmit={yeniRolOlustur}>
                <div className="form-grid">
                  <div className="form-group">
                    <label>Rol Adi *</label>
                    <input type="text" value={yeniRolForm.baslik}
                      onChange={e => {
                        const baslik = e.target.value;
                        const anahtar = anahtarDonustur(baslik);
                        setYeniRolForm({ baslik, anahtar });
                      }}
                      placeholder="or. Proje Yoneticisi" required />
                  </div>
                  <div className="form-group">
                    <label>Rol Anahtari *</label>
                    <input type="text" value={yeniRolForm.anahtar}
                      onChange={e => setYeniRolForm(prev => ({ ...prev, anahtar: anahtarDonustur(e.target.value) }))}
                      placeholder="or. proje-yoneticisi" required />
                    <span style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>Kucuk harf ve tire kullanin. Rol adindan otomatik olusturulur.</span>
                  </div>
                </div>
                <div style={{ marginTop: '1rem', display: 'flex', gap: '8px' }}>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Olusturuluyor...' : 'Olustur'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setPanel('yetkiler')}>Iptal</button>
                </div>
              </form>
            </div>
          ) : seciliRol ? (
            <div className="card">
              <div style={{ marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h3 style={{ fontSize: '16px', fontFamily: 'DM Sans', fontWeight: '600', marginBottom: '2px' }}>{seciliRol.baslik} - Modul Yetkileri</h3>
                  <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>Bu rolun erisebilecegi modulleri secin.</p>
                </div>
                <button type="button" className="btn btn-primary" disabled={yukleniyor} onClick={yetkileriGuncelle}>
                  {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
              </div>
              {gruplar.map(grup => (
                <div key={grup} style={{ marginBottom: '1.25rem' }}>
                  <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.75rem' }}>{grup}</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {moduller.filter(m => m.grup === grup).map(m => (
                      <label key={m.anahtar} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '0.6rem 0.75rem', border: '1px solid ' + (rolYetkileri.includes(m.anahtar) ? 'var(--mavi)' : 'var(--border)'), borderRadius: 'var(--radius-sm)', cursor: 'pointer', background: rolYetkileri.includes(m.anahtar) ? 'var(--mavi-acik)' : 'var(--beyaz)', transition: 'all 0.15s' }}>
                        <input type="checkbox" checked={rolYetkileri.includes(m.anahtar)} onChange={() => toggleModul(m.anahtar)} />
                        <span style={{ fontSize: '14px', color: rolYetkileri.includes(m.anahtar) ? 'var(--mavi)' : 'var(--yazi)', fontWeight: rolYetkileri.includes(m.anahtar) ? '500' : '400' }}>{m.baslik}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="card" style={{ textAlign: 'center', padding: '3rem', color: 'var(--yazi-ikincil)' }}>
              Soldan bir rol secin.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default RolYonetimiPage;
